(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-product-popup-slider"] && !Shopify.designMode) return;
  try {
    const BLOG_PRODUCT_POPUP_STORAGE_KEY = 'blog-product-popup-slider-collapsed';

  function initToggleButton(wrapper) {
    const toggleButton = document.querySelector('.blog-product-popup-slider__toggle-button');

    if (!wrapper || !toggleButton) return;

    function updateButtonState() {
      const collapsed = wrapper.classList.contains('blog-product-popup-slider__wrapper--collapsed');

      toggleButton.setAttribute('aria-expanded', String(!collapsed));
      toggleButton.setAttribute('aria-label', collapsed ? 'Open product slider' : 'Close product slider');
    }

    function handleToggle() {
      const collapsed = wrapper.classList.toggle('blog-product-popup-slider__wrapper--collapsed');
      updateButtonState();

      try {
        window.sessionStorage.setItem(BLOG_PRODUCT_POPUP_STORAGE_KEY, String(collapsed));
      } catch (error) {}
    }

    toggleButton.addEventListener('click', handleToggle);

    let storedCollapsed = null;
    try {
      storedCollapsed = window.sessionStorage.getItem(BLOG_PRODUCT_POPUP_STORAGE_KEY);
    } catch (error) {}

    if (storedCollapsed !== 'true') {
      wrapper.classList.remove('blog-product-popup-slider__wrapper--collapsed');
    }
    updateButtonState();
  }

  function initPagination() {
    const PRODUCTS_PER_PAGE = 2;

    const productsList = document.querySelector('.blog-product-popup-slider__products');
    const pagination = document.querySelector('.blog-product-popup-slider__pagination');

    if (!productsList || !pagination) return;

    const dotTemplate = pagination.querySelector('.blog-product-popup-slider__pagination-dot').cloneNode(true);

    function scrollToDot(index, dotCount) {
      const maxScrollLeft = productsList.scrollWidth - productsList.clientWidth;
      const scrollRatio = dotCount > 1 ? index / (dotCount - 1) : 0;

      productsList.scrollTo({
        left: scrollRatio * maxScrollLeft,
        behavior: 'smooth',
      });
    }

    function updateActiveDot() {
      const circles = pagination.querySelectorAll('circle');
      if (!circles.length) return;

      const maxScrollLeft = productsList.scrollWidth - productsList.clientWidth;
      const scrollRatio = maxScrollLeft > 0 ? productsList.scrollLeft / maxScrollLeft : 0;
      const activeIndex = Math.round(scrollRatio * (circles.length - 1));

      circles.forEach(function (circle, index) {
        circle.setAttribute(
          'fill',
          index === activeIndex ? 'var(--ne-color-white, #ffffff)' : 'var(--ne-primary, #f0ff00)'
        );
      });
    }

    function renderDots() {
      const dotCount = Math.ceil(productsList.children.length / PRODUCTS_PER_PAGE);

      pagination.innerHTML = '';
      for (let i = 0; i < dotCount; i++) {
        const dot = dotTemplate.cloneNode(true);
        dot.setAttribute('aria-label', 'Switch to group ' + (i + 1));
        dot.addEventListener('click', function () {
          scrollToDot(i, dotCount);
        });
        pagination.appendChild(dot);
      }

      updateActiveDot();
    }

    renderDots();
    productsList.addEventListener('scroll', updateActiveDot);
  }

  function initMobileAppearOffset(wrapper) {
    if (!wrapper) return;

    let hasInteracted = false;
    try {
      hasInteracted = window.sessionStorage.getItem(BLOG_PRODUCT_POPUP_STORAGE_KEY) !== null;
    } catch (error) {}

    if (hasInteracted) {
      wrapper.classList.remove('blog-product-popup-slider__wrapper--mobile-pending');
      return;
    }

    const offset = parseFloat(wrapper.dataset.mobileAppearOffset);
    if (!offset || Number.isNaN(offset)) return;

    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
    let revealed = false;

    function checkScrollPosition() {
      if (!mobileMediaQuery.matches) return;

      if (window.scrollY >= offset) {
        revealed = true;
        wrapper.classList.remove('blog-product-popup-slider__wrapper--mobile-pending');
        window.removeEventListener('scroll', checkScrollPosition);
      }
    }

    function handleMediaChange(event) {
      if (!event.matches) {
        revealed = false;
        wrapper.classList.remove('blog-product-popup-slider__wrapper--mobile-pending');
        window.removeEventListener('scroll', checkScrollPosition);
      } else if (!revealed) {
        wrapper.classList.add('blog-product-popup-slider__wrapper--mobile-pending');
        window.addEventListener('scroll', checkScrollPosition, { passive: true });
        checkScrollPosition();
      }
    }

    if (mobileMediaQuery.matches) {
      window.addEventListener('scroll', checkScrollPosition, { passive: true });
      checkScrollPosition();
    }

    mobileMediaQuery.addEventListener('change', handleMediaChange);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.blog-product-popup-slider__wrapper');
    initToggleButton(wrapper);
    initPagination();
    initMobileAppearOffset(wrapper);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flyout"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // If no flyouts, then no triggers needed
    var triggers = document.querySelectorAll('[data-flyout-trigger]');
    if (!triggers.length) {
      return;
    }

    // Move to body so it is a real flyout/modal
    document.querySelectorAll('.flyout').forEach(function (flyout) {
      if (flyout.parentElement !== document.body) {
        document.body.appendChild(flyout);
      }
    });

    // Helpers for open & close
    function openFlyout(flyout) {
      flyout.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
    function closeFlyout(flyout) {
      flyout.classList.add('hidden');
      document.body.style.overflow = '';
    }

    // Add triggers for open & close
    triggers.forEach(function (trigger) {
      var flyout = document.getElementById(trigger.getAttribute('data-flyout-trigger'));
      if (!flyout) {
        return;
      }

      // Open on trigger click
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openFlyout(flyout);
      });

      // Close on close button click
      flyout.querySelector('.flyout__close').addEventListener('click', function () {
        closeFlyout(flyout);
      });

      // Close on click outside
      flyout.addEventListener('click', function (event) {
        if (event.target === flyout) {
          closeFlyout(flyout);
        }
      });
    });

    // Close on "Escape" key
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') {
        return;
      }
      document.querySelectorAll('.flyout:not(.hidden)').forEach(closeFlyout);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-quality-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Make sure its on the PDP
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) {
      return;
    }

    // Make sure only one bar per variant
    var bars = productSection.querySelectorAll('[data-gallery-quality-bar]');
    if (!bars.length) {
      return;
    }

    // Helper to only show the bar for the current variant
    function updateBars() {
      var variantId = productSection.getAttribute('data-current-product-id');
      if (!variantId) {
        return;
      }

      // Apply styling to the shown bar, hide others
      bars.forEach(function (bar) {
        var matches = String(bar.getAttribute('data-product-id')) === String(variantId);
        bar.classList.toggle('hidden', !matches);
        bar.style.display = matches ? '' : 'none';
      });
    }

    // Update if image changes (variang change)
    productSection.addEventListener('gallery:media-changed', updateBars);
  })();
  } catch(e) { console.error(e); }
})();

})();
